"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddButton = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const add_button_styles_1 = require("./add-button.styles");
const localization_1 = require("../../../../../../localization");
const AddButton = (_a) => {
    var { entityName, onClick } = _a, props = __rest(_a, ["entityName", "onClick"]);
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    return (react_1.default.createElement(add_button_styles_1.StyledAddButton, Object.assign(Object.assign({ rounded: true, size: "large", color: "primary", variant: "outlined", endIcon: react_1.default.createElement(ui_components_1.Icon, { variant: "plus" }) }, props), { title: t({ key: 'ADD_ENTITY', values: { entity: entityName } }), onClick: onClick })));
};
exports.AddButton = AddButton;
exports.default = exports.AddButton;
